// extracted by mini-css-extract-plugin
export var fullHeightState = "_53-7";
export var headerCell = "_53-1";
export var loadingStateCell = "_53-4";
export var rowWrapper = "_53-3";
export var standaloneTable = "_53-8";
export var standaloneTableWithBodyFill = "_53-9";
export var stateCell = "_53-5";
export var table = "_53-0";
export var tableBodyFiller = "_53-6";
export var white = "_53-2";